/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AppointmentTimeSlotDto } from '../models/AppointmentTimeSlotDto';
import type { AppointmentTypeSlotReq } from '../models/AppointmentTypeSlotReq';
import type { AppointmentTypeSlotSlotsDto } from '../models/AppointmentTypeSlotSlotsDto';
import type { AppointmentTypeTableDto } from '../models/AppointmentTypeTableDto';
import type { AppointTypeTableRowDto } from '../models/AppointTypeTableRowDto';
import type { BonNumberUpdateModel } from '../models/BonNumberUpdateModel';
import type { BookingSummaryModel } from '../models/BookingSummaryModel';
import type { BranchType } from '../models/BranchType';
import type { CaseSaveModel } from '../models/CaseSaveModel';
import type { CategoryLabourLinesResp } from '../models/CategoryLabourLinesResp';
import type { CustomerData } from '../models/CustomerData';
import type { DailyHourUpdateDto } from '../models/DailyHourUpdateDto';
import type { HoursBookedAvailabilityReq } from '../models/HoursBookedAvailabilityReq';
import type { HoursBookedAvailabilityResp } from '../models/HoursBookedAvailabilityResp';
import type { LabourAvailabilityUpdateDto } from '../models/LabourAvailabilityUpdateDto';
import type { LabourCategoryDto } from '../models/LabourCategoryDto';
import type { LaboursBookingModel } from '../models/LaboursBookingModel';
import type { NoteModel } from '../models/NoteModel';
import type { NoteSaveModel } from '../models/NoteSaveModel';
import type { NoteSaveRequest } from '../models/NoteSaveRequest';
import type { PagedWorkShopLogListData } from '../models/PagedWorkShopLogListData';
import type { QualificationCategoryDto } from '../models/QualificationCategoryDto';
import type { QualificationCategoryReq } from '../models/QualificationCategoryReq';
import type { ServiceBalanceModel } from '../models/ServiceBalanceModel';
import type { SignedDocumentsModel } from '../models/SignedDocumentsModel';
import type { SoLabourWithLoadStatusModel } from '../models/SoLabourWithLoadStatusModel';
import type { SoOperData } from '../models/SoOperData';
import type { TechnicianJobDetailedModel } from '../models/TechnicianJobDetailedModel';
import type { VehicleTypeDayDto } from '../models/VehicleTypeDayDto';
import type { VehicleTypeSlotDto } from '../models/VehicleTypeSlotDto';
import type { WipAppointmentPreparationEditModel } from '../models/WipAppointmentPreparationEditModel';
import type { WipAppointmentPreparationModel } from '../models/WipAppointmentPreparationModel';
import type { WIPDetailedLaboursAndPartsModel } from '../models/WIPDetailedLaboursAndPartsModel';
import type { WIPDetailedModel } from '../models/WIPDetailedModel';
import type { WipPartOrderFullModel } from '../models/WipPartOrderFullModel';
import type { WipPreparationNoteSaveModel } from '../models/WipPreparationNoteSaveModel';
import type { WIPStatusEnum } from '../models/WIPStatusEnum';
import type { WipStatusSubmitModel } from '../models/WipStatusSubmitModel';
import type { WorkshopDetailedModel } from '../models/WorkshopDetailedModel';
import type { WorkshopFilterType } from '../models/WorkshopFilterType';
import type { WorkshopGlobalFilterType } from '../models/WorkshopGlobalFilterType';
import type { WorkshopLoadingDto } from '../models/WorkshopLoadingDto';
import type { WorkshopModelPagedListData } from '../models/WorkshopModelPagedListData';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class WorkshopService {

  /**
   * @param type
 *
 * 0 = DueIn
 *
 * 1 = CheckedInToday
 *
 * 2 = WorkInProgress
 *
 * 3 = AwaitingCheckedOut
 *
 * 4 = AwaitingOnSite
 *
 * 5 = CompletedNotInvoiced
 *
 * 6 = Invoiced
 *
 * 7 = InvoicedNotCollected
   * @param globalType
 *
 * 0 = External
 *
 * 1 = SalesPreparation
 *
 * 2 = All
   * @param dueInFrom 
   * @param dueInTo 
   * @param dueOutFrom 
   * @param dueOutTo 
   * @param branch
 *
 * 1 = Slough
 *
 * 2 = HighWycombe
 *
 * 3 = Maidenhead
 *
 * 4 = Watford
 *
 * 6 = HemelHempstead
 *
 * 7 = Romford
   * @param operatorBranchId 
   * @param operatorNumber 
   * @param regNo 
   * @param wipNo 
   * @param wipStatus
 *
 * 0 = CheckedIn
 *
 * 1 = InProgress
 *
 * 2 = PausedAwaitingAuthority
 *
 * 3 = PausedTechnicalSupport
 *
 * 4 = PausedWaitingForParts
 *
 * 5 = Completed
 *
 * 6 = ReadyForCollection
 *
 * 7 = PartsOrderedOffSite
 *
 * 8 = PartsOrderedOnSite
 *
 * 9 = JobAuthorised
   * @param partStatus 
   * @param paggingPage 
   * @param paggingPageSize 
   * @returns PagedWorkShopLogListData Success
   * @throws ApiError
   */
  public static getWorkshop(
type?: WorkshopFilterType,
globalType?: WorkshopGlobalFilterType,
dueInFrom?: string,
dueInTo?: string,
dueOutFrom?: string,
dueOutTo?: string,
branch?: BranchType,
operatorBranchId?: number,
operatorNumber?: number,
regNo?: string,
wipNo?: number,
wipStatus?: WIPStatusEnum,
partStatus?: string,
paggingPage?: number,
paggingPageSize?: number,
): CancelablePromise<PagedWorkShopLogListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop',
      query: {
        'Type': type,
        'GlobalType': globalType,
        'DueInFrom': dueInFrom,
        'DueInTo': dueInTo,
        'DueOutFrom': dueOutFrom,
        'DueOutTo': dueOutTo,
        'Branch': branch,
        'Operator.BranchId': operatorBranchId,
        'Operator.Number': operatorNumber,
        'RegNo': regNo,
        'WipNo': wipNo,
        'WipStatus': wipStatus,
        'PartStatus': partStatus,
        'Pagging.Page': paggingPage,
        'Pagging.PageSize': paggingPageSize,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param globalType
 *
 * 0 = External
 *
 * 1 = SalesPreparation
 *
 * 2 = All
   * @param dueInFrom 
   * @param dueInTo 
   * @param dueOutFrom 
   * @param dueOutTo 
   * @param branch
 *
 * 1 = Slough
 *
 * 2 = HighWycombe
 *
 * 3 = Maidenhead
 *
 * 4 = Watford
 *
 * 6 = HemelHempstead
 *
 * 7 = Romford
   * @param operatorBranchId 
   * @param operatorNumber 
   * @param regNo 
   * @param wipNo 
   * @param wipStatus
 *
 * 0 = CheckedIn
 *
 * 1 = InProgress
 *
 * 2 = PausedAwaitingAuthority
 *
 * 3 = PausedTechnicalSupport
 *
 * 4 = PausedWaitingForParts
 *
 * 5 = Completed
 *
 * 6 = ReadyForCollection
 *
 * 7 = PartsOrderedOffSite
 *
 * 8 = PartsOrderedOnSite
 *
 * 9 = JobAuthorised
   * @param partStatus 
   * @param paggingPage 
   * @param paggingPageSize 
   * @returns WorkshopModelPagedListData Success
   * @throws ApiError
   */
  public static getWorkshopCards(
globalType?: WorkshopGlobalFilterType,
dueInFrom?: string,
dueInTo?: string,
dueOutFrom?: string,
dueOutTo?: string,
branch?: BranchType,
operatorBranchId?: number,
operatorNumber?: number,
regNo?: string,
wipNo?: number,
wipStatus?: WIPStatusEnum,
partStatus?: string,
paggingPage?: number,
paggingPageSize?: number,
): CancelablePromise<WorkshopModelPagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/cards',
      query: {
        'GlobalType': globalType,
        'DueInFrom': dueInFrom,
        'DueInTo': dueInTo,
        'DueOutFrom': dueOutFrom,
        'DueOutTo': dueOutTo,
        'Branch': branch,
        'Operator.BranchId': operatorBranchId,
        'Operator.Number': operatorNumber,
        'RegNo': regNo,
        'WipNo': wipNo,
        'WipStatus': wipStatus,
        'PartStatus': partStatus,
        'Pagging.Page': paggingPage,
        'Pagging.PageSize': paggingPageSize,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param type
 *
 * 0 = DueIn
 *
 * 1 = CheckedInToday
 *
 * 2 = WorkInProgress
 *
 * 3 = AwaitingCheckedOut
 *
 * 4 = AwaitingOnSite
 *
 * 5 = CompletedNotInvoiced
 *
 * 6 = Invoiced
 *
 * 7 = InvoicedNotCollected
   * @param globalType
 *
 * 0 = External
 *
 * 1 = SalesPreparation
 *
 * 2 = All
   * @param dueInFrom 
   * @param dueInTo 
   * @param dueOutFrom 
   * @param dueOutTo 
   * @param branch
 *
 * 1 = Slough
 *
 * 2 = HighWycombe
 *
 * 3 = Maidenhead
 *
 * 4 = Watford
 *
 * 6 = HemelHempstead
 *
 * 7 = Romford
   * @param operatorBranchId 
   * @param operatorNumber 
   * @param regNo 
   * @param wipNo 
   * @param wipStatus
 *
 * 0 = CheckedIn
 *
 * 1 = InProgress
 *
 * 2 = PausedAwaitingAuthority
 *
 * 3 = PausedTechnicalSupport
 *
 * 4 = PausedWaitingForParts
 *
 * 5 = Completed
 *
 * 6 = ReadyForCollection
 *
 * 7 = PartsOrderedOffSite
 *
 * 8 = PartsOrderedOnSite
 *
 * 9 = JobAuthorised
   * @param partStatus 
   * @param paggingPage 
   * @param paggingPageSize 
   * @returns SoOperData Success
   * @throws ApiError
   */
  public static getWorkshopOperators(
type?: WorkshopFilterType,
globalType?: WorkshopGlobalFilterType,
dueInFrom?: string,
dueInTo?: string,
dueOutFrom?: string,
dueOutTo?: string,
branch?: BranchType,
operatorBranchId?: number,
operatorNumber?: number,
regNo?: string,
wipNo?: number,
wipStatus?: WIPStatusEnum,
partStatus?: string,
paggingPage?: number,
paggingPageSize?: number,
): CancelablePromise<Array<SoOperData>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/operators',
      query: {
        'Type': type,
        'GlobalType': globalType,
        'DueInFrom': dueInFrom,
        'DueInTo': dueInTo,
        'DueOutFrom': dueOutFrom,
        'DueOutTo': dueOutTo,
        'Branch': branch,
        'Operator.BranchId': operatorBranchId,
        'Operator.Number': operatorNumber,
        'RegNo': regNo,
        'WipNo': wipNo,
        'WipStatus': wipStatus,
        'PartStatus': partStatus,
        'Pagging.Page': paggingPage,
        'Pagging.PageSize': paggingPageSize,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param wipNo 
   * @param regno 
   * @returns BookingSummaryModel Success
   * @throws ApiError
   */
  public static getWorkshopBookingSummary(
wipNo?: number,
regno?: string,
): CancelablePromise<BookingSummaryModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/booking-summary',
      query: {
        'wipNo': wipNo,
        'regno': regno,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param wipNo 
   * @param branchId 
   * @returns any Success
   * @throws ApiError
   */
  public static getWorkshopVhcVideo(
wipNo?: number,
branchId?: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/vhc-video',
      query: {
        'wipNo': wipNo,
        'branchId': branchId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param soHeaderId 
   * @returns any Success
   * @throws ApiError
   */
  public static getWorkshopClocking(
soHeaderId?: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/clocking',
      query: {
        'soHeaderId': soHeaderId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param soHeaderId 
   * @returns any Success
   * @throws ApiError
   */
  public static getWorkshopQualityTestDrive(
soHeaderId?: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/quality-test-drive',
      query: {
        'soHeaderId': soHeaderId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param regno 
   * @param email 
   * @returns ServiceBalanceModel Success
   * @throws ApiError
   */
  public static getWorkshopAdvanceBalance(
regno?: string,
email?: string,
): CancelablePromise<ServiceBalanceModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/advance-balance',
      query: {
        'regno': regno,
        'email': email,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @returns WorkshopDetailedModel Success
   * @throws ApiError
   */
  public static getWorkshop1(
id: number,
): CancelablePromise<WorkshopDetailedModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns number Success
   * @throws ApiError
   */
  public static postWorkshopWipAppointment(
requestBody?: WipAppointmentPreparationModel,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/workshop/wip-appointment',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns number Success
   * @throws ApiError
   */
  public static putWorkshopWipAppointment(
id: number,
requestBody?: WipAppointmentPreparationEditModel,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/workshop/wip-appointment/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns number Success
   * @throws ApiError
   */
  public static postWorkshopWipStatus(
id: number,
requestBody?: WipStatusSubmitModel,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/workshop/wip-status/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param soHeaderId 
   * @returns SoLabourWithLoadStatusModel Success
   * @throws ApiError
   */
  public static getWorkshopWipLabours(
soHeaderId?: number,
): CancelablePromise<Array<SoLabourWithLoadStatusModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/wip-labours',
      query: {
        'soHeaderId': soHeaderId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param soHeaderId 
   * @param isFilterStatus 
   * @returns any Success
   * @throws ApiError
   */
  public static getWorkshopWipParts(
soHeaderId?: number,
isFilterStatus?: boolean,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/wip-parts',
      query: {
        'soHeaderId': soHeaderId,
        'isFilterStatus': isFilterStatus,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public static getWorkshopWipPartsStatuses(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/wip-parts-statuses',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param soHeaderId 
   * @returns any Success
   * @throws ApiError
   */
  public static getWorkshopWipOrders(
soHeaderId?: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/wip-orders',
      query: {
        'soHeaderId': soHeaderId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param soHeaderId 
   * @returns WipPartOrderFullModel Success
   * @throws ApiError
   */
  public static getWorkshopWipPartsOrders(
soHeaderId?: number,
): CancelablePromise<Array<WipPartOrderFullModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/wip-parts-orders',
      query: {
        'soHeaderId': soHeaderId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param soHeaderId 
   * @returns WIPDetailedModel Success
   * @throws ApiError
   */
  public static getWorkshopWipDetails(
soHeaderId?: number,
): CancelablePromise<WIPDetailedModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/wip-details',
      query: {
        'soHeaderId': soHeaderId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param soHeaderId 
   * @returns WIPDetailedLaboursAndPartsModel Success
   * @throws ApiError
   */
  public static getWorkshopWipDetailsLaboursAndParts(
soHeaderId?: number,
): CancelablePromise<Array<WIPDetailedLaboursAndPartsModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/wip-details-labours-and-parts',
      query: {
        'soHeaderId': soHeaderId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param soHeaderId 
   * @returns any Success
   * @throws ApiError
   */
  public static getWorkshopCheckIn(
soHeaderId?: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/check-in',
      query: {
        'soHeaderId': soHeaderId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postWorkshopNotes(
requestBody?: NoteSaveModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/workshop/notes',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param soHeaderId 
   * @returns NoteModel Success
   * @throws ApiError
   */
  public static getWorkshopNotes(
soHeaderId?: number,
): CancelablePromise<NoteModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/notes',
      query: {
        'soHeaderId': soHeaderId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postWorkshopDigitalWipNotes(
requestBody?: NoteSaveRequest,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/workshop/digital-wip-notes',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postWorkshopWipPrepNotes(
id: number,
requestBody?: WipPreparationNoteSaveModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/workshop/wip-prep/{id}/notes',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postWorkshopCases(
requestBody?: CaseSaveModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/workshop/cases',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param email 
   * @param regno 
   * @param soHeaderId 
   * @returns any Success
   * @throws ApiError
   */
  public static getWorkshopVauchers(
email?: string,
regno?: string,
soHeaderId?: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/vauchers',
      query: {
        'email': email,
        'regno': regno,
        'soHeaderId': soHeaderId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static putWorkshopBon(
id: number,
requestBody?: BonNumberUpdateModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/workshop/bon/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param soHeaderId 
   * @returns TechnicianJobDetailedModel Success
   * @throws ApiError
   */
  public static getWorkshopTechJob(
id?: number,
soHeaderId?: number,
): CancelablePromise<TechnicianJobDetailedModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/tech-job',
      query: {
        'id': id,
        'soHeaderId': soHeaderId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns CustomerData Success
   * @throws ApiError
   */
  public static getWorkshopCdkCustomer(
id: number,
): CancelablePromise<CustomerData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/{id}/cdk-customer',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @param cdkCustomerId 
   * @returns any Created
   * @throws ApiError
   */
  public static postWorkshopCdkCustomer(
id: number,
cdkCustomerId?: string,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/workshop/{id}/cdk-customer',
      path: {
        'id': id,
      },
      query: {
        'cdkCustomerId': cdkCustomerId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @param isSms 
   * @returns any Success
   * @throws ApiError
   */
  public static postWorkshopSendReadyForCollection(
id: number,
isSms?: boolean,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/workshop/{id}/send-ready-for-collection',
      path: {
        'id': id,
      },
      query: {
        'isSms': isSms,
      },
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static postWorkshopSendSmsQuotes(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/workshop/{id}/send-sms-quotes',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Get all soHeader's signed documents
   * @param id SoHeader Id
   * @returns SignedDocumentsModel Success
   * @throws ApiError
   */
  public static getWorkshopSignedDocs(
id: number,
): CancelablePromise<Array<SignedDocumentsModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/{id}/signed-docs',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param from 
   * @param to 
   * @param branch
 *
 * 1 = Slough
 *
 * 2 = HighWycombe
 *
 * 3 = Maidenhead
 *
 * 4 = Watford
 *
 * 6 = HemelHempstead
 *
 * 7 = Romford
   * @returns WorkshopLoadingDto Success
   * @throws ApiError
   */
  public static getWorkshopAvailabilities(
from?: string,
to?: string,
branch?: BranchType,
): CancelablePromise<WorkshopLoadingDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/availabilities',
      query: {
        'From': from,
        'To': to,
        'Branch': branch,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putWorkshopAvailabilities(
requestBody?: DailyHourUpdateDto,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/workshop/availabilities',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param from 
   * @param to 
   * @param branch
 *
 * 1 = Slough
 *
 * 2 = HighWycombe
 *
 * 3 = Maidenhead
 *
 * 4 = Watford
 *
 * 6 = HemelHempstead
 *
 * 7 = Romford
   * @returns LaboursBookingModel Success
   * @throws ApiError
   */
  public static getWorkshopAvailabilitiesLabour(
from?: string,
to?: string,
branch?: BranchType,
): CancelablePromise<LaboursBookingModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/availabilities/labour',
      query: {
        'From': from,
        'To': to,
        'Branch': branch,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putWorkshopAvailabilitiesLabour(
requestBody?: LabourAvailabilityUpdateDto,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/workshop/availabilities/labour',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param branch
 *
 * 1 = Slough
 *
 * 2 = HighWycombe
 *
 * 3 = Maidenhead
 *
 * 4 = Watford
 *
 * 6 = HemelHempstead
 *
 * 7 = Romford
   * @returns QualificationCategoryDto Success
   * @throws ApiError
   */
  public static getWorkshopQualificationCategories(
branch?: BranchType,
): CancelablePromise<Array<QualificationCategoryDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/qualification-categories',
      query: {
        'Branch': branch,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postWorkshopQualificationCategories(
requestBody?: QualificationCategoryReq,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/workshop/qualification-categories',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param id 
   * @returns QualificationCategoryDto Success
   * @throws ApiError
   */
  public static getWorkshopQualificationCategories1(
id: number,
): CancelablePromise<QualificationCategoryDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/qualification-categories/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns boolean Created
   * @throws ApiError
   */
  public static putWorkshopQualificationCategories(
id: number,
requestBody?: QualificationCategoryReq,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/workshop/qualification-categories/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param id 
   * @returns LabourCategoryDto Success
   * @throws ApiError
   */
  public static deleteWorkshopQualificationCategories(
id: number,
): CancelablePromise<LabourCategoryDto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/workshop/qualification-categories/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns LabourCategoryDto Success
   * @throws ApiError
   */
  public static getWorkshopLabourCategories(): CancelablePromise<Array<LabourCategoryDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/labour-categories',
    });
  }

  /**
   * @param labourCategoryName 
   * @param value 
   * @returns number Created
   * @throws ApiError
   */
  public static postWorkshopLabourCategories(
labourCategoryName?: string,
value?: number,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/workshop/labour-categories',
      query: {
        'LabourCategoryName': labourCategoryName,
        'Value': value,
      },
    });
  }

  /**
   * @param id 
   * @returns LabourCategoryDto Success
   * @throws ApiError
   */
  public static getWorkshopLabourCategories1(
id: number,
): CancelablePromise<LabourCategoryDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/labour-categories/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id 
   * @param labourCategoryName 
   * @param value 
   * @returns LabourCategoryDto Success
   * @throws ApiError
   */
  public static putWorkshopLabourCategories(
id: number,
labourCategoryName?: string,
value?: number,
): CancelablePromise<LabourCategoryDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/workshop/labour-categories/{id}',
      path: {
        'id': id,
      },
      query: {
        'LabourCategoryName': labourCategoryName,
        'Value': value,
      },
    });
  }

  /**
   * @param id 
   * @returns LabourCategoryDto Success
   * @throws ApiError
   */
  public static deleteWorkshopLabourCategories(
id: number,
): CancelablePromise<LabourCategoryDto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/workshop/labour-categories/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns QualificationCategoryDto Success
   * @throws ApiError
   */
  public static getWorkshopLabourQualifications(): CancelablePromise<Array<QualificationCategoryDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/labour-qualifications',
    });
  }

  /**
   * @param requestBody 
   * @returns any Created
   * @throws ApiError
   */
  public static postWorkshopHoursBookedAvailabilities(
requestBody?: HoursBookedAvailabilityReq,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/workshop/hours-booked-availabilities',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param from 
   * @param to 
   * @param branch
 *
 * 1 = Slough
 *
 * 2 = HighWycombe
 *
 * 3 = Maidenhead
 *
 * 4 = Watford
 *
 * 6 = HemelHempstead
 *
 * 7 = Romford
   * @returns HoursBookedAvailabilityResp Success
   * @throws ApiError
   */
  public static getWorkshopHoursBookedAvailabilities(
from?: string,
to?: string,
branch?: BranchType,
): CancelablePromise<Array<HoursBookedAvailabilityResp>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/hours-booked-availabilities',
      query: {
        'From': from,
        'To': to,
        'Branch': branch,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns HoursBookedAvailabilityResp Success
   * @throws ApiError
   */
  public static deleteWorkshopHoursBookedAvailabilities(
id: number,
): CancelablePromise<Array<HoursBookedAvailabilityResp>> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/workshop/hours-booked-availabilities/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param soHeaderId 
   * @param scheduleDate 
   * @param branch
 *
 * 1 = Slough
 *
 * 2 = HighWycombe
 *
 * 3 = Maidenhead
 *
 * 4 = Watford
 *
 * 6 = HemelHempstead
 *
 * 7 = Romford
   * @returns CategoryLabourLinesResp Success
   * @throws ApiError
   */
  public static getWorkshopLabourLines(
soHeaderId?: number,
scheduleDate?: string,
branch?: BranchType,
): CancelablePromise<Array<CategoryLabourLinesResp>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/labour-lines',
      query: {
        'SoHeaderId': soHeaderId,
        'ScheduleDate': scheduleDate,
        'Branch': branch,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * Get data for Appointment Configuration Table
   * @param branchId Id of branch
   * @returns AppointmentTypeTableDto Success
   * @throws ApiError
   */
  public static getWorkshopAppointmentsConfigurations(
branchId?: number,
): CancelablePromise<AppointmentTypeTableDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/appointments/configurations',
      query: {
        'branchId': branchId,
      },
    });
  }

  /**
   * @param dateFrom 
   * @param dateTo 
   * @param branchId
 *
 * 1 = Slough
 *
 * 2 = HighWycombe
 *
 * 3 = Maidenhead
 *
 * 4 = Watford
 *
 * 6 = HemelHempstead
 *
 * 7 = Romford
   * @returns AppointTypeTableRowDto Success
   * @throws ApiError
   */
  public static getWorkshopAppointmentsAvailableSlots(
dateFrom?: string,
dateTo?: string,
branchId?: BranchType,
): CancelablePromise<Array<AppointTypeTableRowDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/appointments/available-slots',
      query: {
        'DateFrom': dateFrom,
        'DateTo': dateTo,
        'BranchId': branchId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param appointmentId 
   * @param dateFrom 
   * @param dateTo 
   * @param branchId
 *
 * 1 = Slough
 *
 * 2 = HighWycombe
 *
 * 3 = Maidenhead
 *
 * 4 = Watford
 *
 * 6 = HemelHempstead
 *
 * 7 = Romford
   * @returns AppointmentTimeSlotDto Success
   * @throws ApiError
   */
  public static getWorkshopAppointmentsAvailableDays(
appointmentId?: number,
dateFrom?: string,
dateTo?: string,
branchId?: BranchType,
): CancelablePromise<Record<string, Array<AppointmentTimeSlotDto>>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/appointments/available-days',
      query: {
        'AppointmentId': appointmentId,
        'DateFrom': dateFrom,
        'DateTo': dateTo,
        'BranchId': branchId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

  /**
   * Get slots for AppointmentTypeSlot
   * @param appTypeSlotId AppointmentTypeSlot Id
   * @returns AppointmentTypeSlotSlotsDto Success
   * @throws ApiError
   */
  public static getWorkshopAppointmentsSlots(
appTypeSlotId?: number,
): CancelablePromise<AppointmentTypeSlotSlotsDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/appointments/slots',
      query: {
        'appTypeSlotId': appTypeSlotId,
      },
    });
  }

  /**
   * Update AppointmentTypeSlot Status
   * @param aTypeId AppointmentTypeSlot Id
   * @param status AppointmentTypeSlot Status
   * @returns boolean Success
   * @throws ApiError
   */
  public static putWorkshopAppointmentsSlot(
aTypeId: number,
status: boolean,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/workshop/appointments/{aTypeId}/slot/{status}',
      path: {
        'aTypeId': aTypeId,
        'status': status,
      },
    });
  }

  /**
   * Create slots for AppointmentTypeSlot
   * @param aTypeId AppointmentTypeSlot Id
   * @param requestBody AppointmentTypeSlot Input
   * @returns number Success
   * @throws ApiError
   */
  public static putWorkshopAppointmentsSlots(
aTypeId: number,
requestBody?: AppointmentTypeSlotReq,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/workshop/appointments/{aTypeId}/slots',
      path: {
        'aTypeId': aTypeId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * Update Slot status
   * @param aTypeId AppointmentTypeSlot Id
   * @param slotId Slot Id
   * @param isActive Slot Status
   * @returns boolean Success
   * @throws ApiError
   */
  public static putWorkshopAppointmentsSlot1(
aTypeId: number,
slotId: number,
isActive: boolean,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/workshop/appointments/{aTypeId}/slot/{slotId}/{isActive}',
      path: {
        'aTypeId': aTypeId,
        'slotId': slotId,
        'isActive': isActive,
      },
    });
  }

  /**
   * Add Physical Slots of same pattern to keep future period of available Physical Slots
   * @returns boolean Success
   * @throws ApiError
   */
  public static getWorkshopExtendPhysicalSlots(): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/extend/physical-slots',
    });
  }

  /**
   * Get data for Vehicle Type Configuration Table
   * @param branchId Branch Id
   * @param date Current date
   * @returns VehicleTypeSlotDto Success
   * @throws ApiError
   */
  public static getWorkshopVehiclesConfigurations(
branchId?: number,
date?: string,
): CancelablePromise<Array<VehicleTypeSlotDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/vehicles/configurations',
      query: {
        'branchId': branchId,
        'date': date,
      },
    });
  }

  /**
   * Update VehicleTypeSlot maximum available count of slots per day
   * @param slotId VehicleTypeSlotId
   * @param branchId Branch Id
   * @param maxSlotsCount Maximum slots count
   * @returns boolean Success
   * @throws ApiError
   */
  public static putWorkshopVehiclesSlotMaxcount(
slotId: number,
branchId?: number,
maxSlotsCount?: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/workshop/vehicles/slot/{slotId}/maxcount',
      path: {
        'slotId': slotId,
      },
      query: {
        'branchId': branchId,
        'maxSlotsCount': maxSlotsCount,
      },
    });
  }

  /**
   * Update VehicleTypeDay maximum available count of slots
   * @param dayId VehicleTypeDayId
   * @param maxSlotsCount Maximum slots count
   * @param vehicleTypeSlotId Vehicle Type Slot Id
   * @param date Day date
   * @returns VehicleTypeDayDto Success
   * @throws ApiError
   */
  public static putWorkshopVehiclesDayMaxcount(
dayId: number,
maxSlotsCount?: number,
vehicleTypeSlotId?: number,
date?: string,
): CancelablePromise<VehicleTypeDayDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/workshop/vehicles/day/{dayId}/maxcount',
      path: {
        'dayId': dayId,
      },
      query: {
        'maxSlotsCount': maxSlotsCount,
        'vehicleTypeSlotId': vehicleTypeSlotId,
        'date': date,
      },
    });
  }

  /**
   * Add VehicleTypeDays with same count of max available slots to keep future period ready
   * @returns boolean Success
   * @throws ApiError
   */
  public static getWorkshopExtendDays(): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/extend/days',
    });
  }

}
